import React, { useState, useCallback } from "react";
import classes from "./DailyHUD.module.css";
import { motion } from "framer-motion";
import { Share2 } from "lucide-react"; // ✅ modern share icon
const DailyHUD = ( { fgRef, onClose }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText("https://dothink.ai/dailyweb");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleZoomOut = useCallback(() => {
  const fg = fgRef.current;
  if (!fg) return;

  // Smoothly move camera further back
  const { x, y, z } = fg.cameraPosition();
  fg.cameraPosition(
    { x: x * 1.2, y: y * 1.2, z: z * 1.2 }, // zoom out smoothly
    { x: 0, y: 0, z: 0 },
    1000 // ms duration
  );

  // Reheat the simulation (spread nodes naturally again)
  if (fg.d3Force) {
    fg.d3Force("charge")?.strength(-60);
    fg.d3Force("link")?.distance(80);
    fg.d3ReheatSimulation();
  }
}, [fgRef]);

  return (
    <motion.div
      className={classes.hud}
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <motion.button
      className={classes.closeButton}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={onClose}
    >
      ✖
    </motion.button>

      <h2 className={classes.title}>Controls</h2>
      <ul className={classes.list}>
        <li>
          <strong>Pan:</strong> Two-finger press & drag
        </li>
        <li>
          <strong>Zoom:</strong> Two-finger drag
        </li>
        <li>
          <strong>Rotate:</strong> One-finger press & drag
        </li>
      </ul>


      <motion.button
        className={classes.motionButton}
        whileHover={{
          scale: 1.1,
          boxShadow: "0 0 15px rgba(0, 136, 255, 0.6)"
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ type: "spring", stiffness: 300, damping: 15 }}
        onClick={handleZoomOut}
      >
        Zoom Out
      </motion.button>

      <motion.button
        whileTap={{ scale: 0.95 }}
        onClick={handleCopy}
        className={classes.shareButton}
      >
        <Share2 size={16} className={classes.icon} />
        {copied ? "Copied!" : "Share"}
      </motion.button>

      
    </motion.div>
  );
};

export default DailyHUD;
